export const getFileExtension = (filename: string): string => {
  const parts = filename.split('.');
  return parts[parts.length - 1];
};

export const DOMParserParseFromString = (str: string): string => {
  return new DOMParser().parseFromString(str, 'text/html').documentElement.textContent || '';
};

export const getHash = (text: string): number => {
  let hash = 0;

  for (let i = 0; i < text.length; i++) {
    const char = text.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }

  return hash;
};

export const modifyString = (str: string) => {
  return {
    original: str,
    hiphen: str.replaceAll(' ', '-'),
    spaced: str.replaceAll('-', ' '),
    lowerCase: str.toLowerCase(),
    lowerCaseHiphen: str.toLowerCase().replaceAll(' ', '-'),
    lowerCaseSpaced: str.toLowerCase().replaceAll('-', ' '),
    upperCase: str.toUpperCase(),
    upperCaseHiphen: str.toUpperCase().replaceAll(' ', '-'),
    upperCaseSpaced: str.toUpperCase().replaceAll('-', ' '),
    capitalize: str.charAt(0).toUpperCase() + str.slice(1),
    capitalizeHiphen: str.charAt(0).toUpperCase() + str.slice(1).replaceAll(' ', '-'),
    capitalizeSpaced: str.charAt(0).toUpperCase() + str.slice(1).replaceAll('-', ' '),
    capitalizeAll: str
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' '),
    capitalizeAllHiphen: str
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join('-'),
    capitalizeAllSpaced: str
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' '),
    capitalizeAllLower: str
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
      .toLowerCase(),
    capitalizeAllLowerHiphen: str
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join('-')
      .toLowerCase(),
    capitalizeAllLowerSpaced: str
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
      .toLowerCase(),
    firstCapitalizedSecondLowerCase: str
      .split(' ')
      .map((word, index) =>
        index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word.toLowerCase()
      )
      .join(' '),
    firstCapitalizedSecondLowerCaseHiphen: str
      .split(' ')
      .map((word, index) =>
        index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word.toLowerCase()
      )
      .join('-'),
    firstCapitalizedSecondLowerCaseSpaced: str
      .split('-')
      .map((word, index) =>
        index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word.toLowerCase()
      )
      .join(' '),
    firstLoweCaseSecondCapitalized: str
      .split(' ')
      .map((word, index) =>
        index === 1 ? word.charAt(0).toUpperCase() + word.slice(1) : word.toLowerCase()
      )
      .join(' '),
    firstLoweCaseSecondCapitalizedHiphen: str
      .split(' ')
      .map((word, index) =>
        index === 1 ? word.charAt(0).toUpperCase() + word.slice(1) : word.toLowerCase()
      )
      .join('-'),
    firstLoweCaseSecondCapitalizedSpaced: str
      .split('-')
      .map((word, index) =>
        index === 1 ? word.charAt(0).toUpperCase() + word.slice(1) : word.toLowerCase()
      )
      .join(' ')
  };
};
